import "rsuite/dist/rsuite.min.css";
import "./styles/App.css";
import './styles/app.scss';
import { CustomProvider } from "rsuite";
import { esES } from "rsuite/esm/locales";
import { StoreProvider } from "./context/AppContext";
import Router from "./router";

function App() {
  return (
    <CustomProvider locale={esES}>
      <StoreProvider>
        <Router />
      </StoreProvider>
    </CustomProvider>
  );
}

export default App;
